// @flow
export { default } from './PartnerHead';



// WEBPACK FOOTER //
// ./src/components/partner/PartnerHead/index.js